module.exports = __webpack_public_path__ + "img/dianhua.65f5f711.png";